import type {
  CarePlanTemplateDetail,
  CarePlanTemplateSummary,
  CreateCarePlanTemplatePayload,
  SaveCarePlanTemplateCyclePayload,
  SaveCarePlanTemplateStepPayload,
  UpdateCarePlanTemplatePayload,
} from "@/types/care-plan-template";

import { requestData } from "@/api/api-config";

const basePath = "admin/care-plan-templates";

async function listCarePlanTemplates(): Promise<
  CarePlanTemplateSummary[] | null
> {
  return await requestData<CarePlanTemplateSummary[]>(basePath, "get");
}

async function getCarePlanTemplate(
  id: string,
): Promise<CarePlanTemplateDetail | null> {
  return await requestData<CarePlanTemplateDetail>(`${basePath}/${id}`, "get");
}

async function createCarePlanTemplate(
  data: CreateCarePlanTemplatePayload,
): Promise<CarePlanTemplateDetail | null> {
  return await requestData<CarePlanTemplateDetail>(basePath, "post", {
    json: data,
  });
}

async function bulkSaveCarePlanTemplate(
  templateId: string,
  data: UpdateCarePlanTemplatePayload & {
    steps: SaveCarePlanTemplateStepPayload[];
    cycles?: SaveCarePlanTemplateCyclePayload[];
  },
): Promise<CarePlanTemplateDetail | null> {
  return await requestData<CarePlanTemplateDetail>(
    `${basePath}/${templateId}/save`,
    "put",
    { json: data },
  );
}

async function deleteCarePlanTemplate(id: string): Promise<boolean | null> {
  return await requestData<boolean>(`${basePath}/${id}`, "delete");
}

export const carePlanTemplateApi = {
  list: listCarePlanTemplates,
  get: getCarePlanTemplate,
  create: createCarePlanTemplate,
  bulkSave: bulkSaveCarePlanTemplate,
  delete: deleteCarePlanTemplate,
};
